import { render } from "./CoachItem.vue?vue&type=template&id=13cf2f3d&scoped=true"
import script from "./CoachItem.vue?vue&type=script&lang=js"
export * from "./CoachItem.vue?vue&type=script&lang=js"

import "./CoachItem.vue?vue&type=style&index=0&id=13cf2f3d&scoped=true&lang=css"

import exportComponent from "D:\\vue\\Vue_Lessons\\coachApps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13cf2f3d"]])

export default __exports__